export enum enmReservationType {
    New = 0,
    Changed = 1,
    Cancelled = 2
}
